export const instantAssistance = {
  // 设备状态 1-未激活 2-已激活 3-已绑定
  deviceStatus: [
    {label: '未激活', value: 1},
    {label: '已激活', value: 2},
    {value: 3, label: '已绑定待生效'},
    {value: 4, label: '已绑定已生效'}
  ],
  // 运行状态 1-正常 2-低电量（电量低于30%)
  runningStatus: [
    {label: '正常', value: 1},
    {label: '低电量', value: 2}
  ],
  // 呼叫状态 1-未呼叫 2-已呼叫
  callStatus: [
    {label: '未呼叫', value: 1},
    {label: '已呼叫', value: 2}
  ],
  // 线索类型 1-碰撞救援  2-SOS一键救援
  orderTypes: [
    {label: '碰撞救援', value: 1},
    {label: 'SOS一键救援', value: 2}
  ],
  // 处理状态 1-未处理 2-已处理
  sendRescueSms: [
    {label: '未处理', value: 1},
    {label: '已处理', value: 2}
  ],
  // 救援电话类型 1-手机号码 2-固定电话
  rescueMobileTypes: [
    {label: '手机号码', value: 1},
    {label: '固定电话', value: 2}
  ]
}

export default {
  instantAssistance
}



// WEBPACK FOOTER //
// ./src/data/instantAssistance.js